import axiosClient from "../common/axios/axiosConfig";
import { ICheckout } from "../common/interfaces/ICheckout";
import { BuyDetailsInterface } from "../components/checkout/CheckoutCommon";
import { IUserData } from "../components/utils/getUserData";
import { showToast } from "../utils/showToast";

interface executeCheckoutResponse {
	success: boolean;
	id: string;
	transactionError?: {
		data?: {
			type?: string;
		};
	};
	message?: string;
}

const executeCheckout = async (
	idCheckout: string,
	personalData: IUserData,
	purchaseData: BuyDetailsInterface | undefined,
	skipPayment = false,
): Promise<executeCheckoutResponse | void> => {
	let personalInfo = {} as ICheckout;
	if (personalData) {
		personalInfo = skipPayment ? { ...personalData, skipPayment } : { ...personalData, skipPayment, dadosCartao: purchaseData };
	}

	try {
		const response = await axiosClient.post<executeCheckoutResponse>("/executar-checkout", {
			idCheckout,
			...personalInfo,
		});
		if (!response.data.success) {
			if (response.data?.transactionError?.data?.type == "card_error") {
				showToast("info", {
					text: "Não foi possível finalizar - verifique as informações do cartão",
				});
			} else if (response?.data?.message === "Schedule isn't valid anymore") {
				showToast("info", {
					text: "O tempo de checkout expirou! Selecione uma nova data ou horário para continuar",
				});
			} else {
				showToast("info", {
					text: "Não foi possível finalizar o agendamento - tente novamente com outra data ou horário",
				});
			}
		}
		return response.data;
	} catch {
		showToast("error", {
			text: "Erro ao finalizar agendamento",
			showConfirmButton: true,
			confirmButtonText: "OK",
		});
	}
};

export default executeCheckout;
